function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState } from "react";
import PropTypes from "prop-types";
// MUI imports
import FormControl from "@mui/material/FormControl";
import InputBase from "@mui/material/InputBase";
import FormHelperText from "@mui/material/FormHelperText";
// @limitless
import { useTranslation } from "@limitless/common/hooks";
import InputLabel from "../input-label/InputLabel";
const MultilineTextField = ({
  value,
  label = "",
  placeholder = "Type here",
  fullWidth,
  required = false,
  error = false,
  disabled = false,
  rows = 2,
  errorText,
  helperText,
  onMaliciousDetected = false,
  onChange,
  ...rest
}) => {
  const {
    id = `${label.trim().toLowerCase() || "no_label"}_multiline_textField`
  } = {
    ...rest
  };
  const {
    t
  } = useTranslation();
  const [maliciousDetected, setMaliciousDetected] = useState(false);
  const checkMalicious = val => {
    const xssRegex = /<script[\s\S]*?>[\s\S]*?<\/script>|javascript:/gi;
    const hasMaliciousContent = xssRegex.test(val || "");
    setMaliciousDetected(hasMaliciousContent);
    if (typeof onMaliciousDetected === "function") {
      onMaliciousDetected(hasMaliciousContent);
    }
  };
  React.useEffect(() => {
    checkMalicious(value);
  }, [value]);
  const handleChange = event => {
    const val = event.target.value;
    checkMalicious(val);
    if (typeof onChange === "function") {
      onChange(event);
    }
  };
  return /*#__PURE__*/React.createElement(FormControl, {
    variant: "standard",
    error: error || maliciousDetected,
    fullWidth: fullWidth,
    disabled: disabled
  }, /*#__PURE__*/React.createElement(InputLabel, {
    label: label,
    id: id,
    required: required,
    shrink: true
  }), /*#__PURE__*/React.createElement(InputBase, _extends({
    id: id,
    placeholder: t(placeholder),
    value: value,
    autoComplete: "off"
  }, rest, {
    sx: {
      height: "auto"
    },
    multiline: true,
    rows: rows,
    variant: "outlined",
    onChange: handleChange
  })), /*#__PURE__*/React.createElement(FormHelperText, {
    id: `${id}-helper`,
    style: {
      marginBottom: "6px"
    }
  }, maliciousDetected ? t("Script tags or malicious content detected. Please remove to proceed ok.") : error ? t(errorText) : t(helperText)));
};
MultilineTextField.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  fullWidth: PropTypes.bool,
  required: PropTypes.bool,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  defaultValue: PropTypes.any,
  rows: PropTypes.number,
  errorText: PropTypes.string,
  helperText: PropTypes.string,
  onChange: PropTypes.func,
  onMaliciousDetected: PropTypes.func
};
export default MultilineTextField;